module.exports = __webpack_public_path__ + "static/media/img_howto_image@2x.f9d44caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_howto_image@2x.png
// module id = 1082
// module chunks = 0